var map = {
	"./app/catalogue/routes.js": 32441,
	"./app/catalogue_page/routes.js": 24102,
	"./app/code_colour/routes.js": 17338,
	"./app/code_contact_type/routes.js": 86797,
	"./app/code_fabric/routes.js": 56826,
	"./app/code_product_category/routes.js": 37251,
	"./app/container/routes.js": 7066,
	"./app/product/routes.js": 47435,
	"./app/routes.js": 10466,
	"./app/stock/routes.js": 31908,
	"./app/store/routes.js": 75690,
	"./app/store_contact/routes.js": 79229,
	"./app/store_order/routes.js": 91872,
	"./app/store_order_line/routes.js": 43580,
	"./app/supplier/routes.js": 16582,
	"./vue-ocom/auth/routes.js": 93103,
	"./vue-ocom/grouppermissions/content_type/routes.js": 31425,
	"./vue-ocom/grouppermissions/group/routes.js": 70078,
	"./vue-ocom/grouppermissions/group_permissions/routes.js": 50733,
	"./vue-ocom/grouppermissions/permission/routes.js": 62707,
	"./vue-ocom/grouppermissions/user/routes.js": 5134,
	"./vue-ocom/reports/routes.js": 71743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9421;